import { render, staticRenderFns } from "./FreezerList.vue?vue&type=template&id=17440570&"
import script from "./FreezerList.vue?vue&type=script&lang=js&"
export * from "./FreezerList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports